import React from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import { getIsUnverified } from '../../publicSession/selectors';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { ArtBrandedMobilePopup } from '../../ArtBrandedPopup';
import Button from '../../Button';
import VerificationEmailInput from '../../VerificationEmailInput';
import s from './VerificationPopupMobile.scss';
const VerificationPopupMobile = ({ actionType, email, resendEmail, onClose })=>{
    const { t } = useTranslation();
    let modalType;
    if (actionType === 'error') {
        modalType = 'error';
    } else if (actionType) {
        modalType = 'action';
    } else {
        modalType = 'welcome';
    }
    const isUnverified = useSelector(getIsUnverified);
    const title = t(`verification.title.${modalType}`, {
        action: t(`verification.action.${actionType}`)
    });
    return /*#__PURE__*/ React.createElement(ArtBrandedMobilePopup, {
        artImageSrc: Url.staticCDNLink('eclipse/sisu/image-11-620625097.jpg'),
        artAuthorUsername: 'AxiomDesign',
        onClose: onClose,
        popupProps: {
            isOpen: true,
            forceTheme: ThemeOptions.DARK
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(`verification.checkEmail.${modalType}`, {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        email: /*#__PURE__*/ React.createElement("span", {
            className: s['email']
        }, email)
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, modalType === 'error' ? /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "verification.instructions.error"
    }, "If the issue persists, try opening the verification link from a different device, and if that doesn't resolve the issue, please", /*#__PURE__*/ React.createElement("a", {
        className: "text-link-level-1-brand",
        href: URLS.SUPPORT
    }, "contact DeviantArt Customer Support"), ".") : t(`verification.instructions.${modalType}`)), /*#__PURE__*/ React.createElement(Button, {
        className: s['resend-button'],
        view: "b3",
        fullWidth: false,
        onClick: ()=>{
            resendEmail();
            onClose && onClose();
        }
    }, t('verification.resend'))), /*#__PURE__*/ React.createElement("div", {
        className: s['footer']
    }, isUnverified ? /*#__PURE__*/ React.createElement("div", {
        className: s['footer-blurb']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "verification.doormatBlurb"
    }, "If you don't recognize this email or no longer have access to it, please contact support at", /*#__PURE__*/ React.createElement("a", {
        target: "_blank",
        rel: "noreferrer",
        href: "mailto:accountrecovery@deviantart.com"
    }, "accountrecovery@deviantart.com"), ' ', "or", /*#__PURE__*/ React.createElement("a", {
        target: "_blank",
        rel: "noreferrer",
        href: "https://www.deviantartsupport.com/en/article/what-should-i-do-if-ive-lost-access-to-my-account"
    }, "learn more here"), ".")) : /*#__PURE__*/ React.createElement("div", {
        className: s['change-email']
    }, t('verification.notEmail', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        email: /*#__PURE__*/ React.createElement("span", {
            className: s['email']
        }, email)
    }), /*#__PURE__*/ React.createElement(VerificationEmailInput, {
        className: s['change-email-input']
    }))));
};
export default VerificationPopupMobile;

//# sourceMappingURL=VerificationPopupMobile.js.map